(function () {
  function initSaleCarousel(root) {
    if (!root || root.dataset.itfSaleCarouselReady === 'true') return;

    root.dataset.itfSaleCarouselReady = 'true';

    const track = root.querySelector('[data-itf-sale-track]');
    const prevButton = root.querySelector('[data-itf-sale-prev]');
    const nextButton = root.querySelector('[data-itf-sale-next]');

    if (!track) return;

    function scrollCarousel(direction) {
      const scrollAmount = track.offsetWidth * 0.8;

      track.scrollBy({
        left: direction * scrollAmount,
        behavior: 'smooth'
      });
    }

    if (prevButton) {
      prevButton.addEventListener('click', function () {
        scrollCarousel(-1);
      });
    }

    if (nextButton) {
      nextButton.addEventListener('click', function () {
        scrollCarousel(1);
      });
    }
  }

  function initAllSaleCarousels(container) {
    const scope = container || document;
    const carousels = Array.from(scope.querySelectorAll('[data-itf-sale-carousel]'));

    carousels.forEach(initSaleCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAllSaleCarousels(document);
    });
  } else {
    initAllSaleCarousels(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAllSaleCarousels(event.target);
  });
})();